<template>
  <b-container>
    <h1 class="mb-3">Store Settings</h1>
    <b-tabs content-class="mt-3">
      <b-tab title="Closures" active>
        <closures></closures>
      </b-tab>
      <b-tab title="Opening Hours">
        <opening-hours></opening-hours>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import OpeningHours from './OpeningHours';
import Closures from './Closures';

export default {
  components: {
    OpeningHours,
    Closures
  }
};
</script>
